import React, { useState, useEffect, useMemo,useCallback } from "react";


import { Button } from '@shadcn/components/ui/button'
import { Card, CardContent as CardBody, CardTitle} from '@shadcn/components/ui/card'
import { CSVLink } from "react-csv";
import useQuery from '../../helpers/JIFI/useQuery';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import moment from 'moment';
import useSKUStatus from "./helpers/useSKUStatus";
import useUpcomingStock from "./helpers/useUpcomingStock";
import debounce from 'lodash/debounce';
import { Row } from "@shadcn/components/ui/row";
import { Col } from "@shadcn/components/ui/col";

// Utility functions
const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return mapToObj(map);
}

const mapToObj = (inputMap) => {
  let obj = {};
  inputMap.forEach(function (value, key) {
    obj[key] = value;
  });
  return obj;
}

// Category array
const categories = [
  'CLASSIC',
  'LIGHT',
  'TRUNK',
  'SET',
  'BAG',
  'ACCESSORIES',
  'MISC',
]


const LineRenderer = React.memo(({ line, tableData, lineIndex, pendingData, pendingDataUS, pendingDataUK, isAUExpanded, isUSExpanded, isUKExpanded, findSKUStatus }) => {
  const renderCell = (content, columnIndex, key) => (
    <td
      key={key}
      style={{ ...(columnIndex === 0 ? {maxWidth: 250, width: 250, minWidth: 250, position:  'sticky', background: 'white', left: 0, zIndex: 3, textWrap: 'auto'}: {})}}
    >
      {content}
      {
        columnIndex === 0 && (
          <>
            <div style={{position: 'absolute', right: 0, top: 0, bottom: 0, width: 0, boxShadow: 'rgba(0, 0, 0, 0.25) 2px -4px 8px 2px', zIndex: 2}} />
            <div style={{position: 'absolute', right: 0, top: 0, bottom: 0, width: 8, background: 'white', zIndex: 3}} />
          </>
        )
      }
    </td>
  );

  return (
    <tr>
      
      { renderCell(
        line[0], 0, `sku-${lineIndex}-1`
      )}
      {renderCell(
        <b>{line[1] + line[2] + line[3] + line[6] + line[7] + line[9] + line[11] + line[16] + line[17] + line[18] + line[19] + line[22] + line[23] + line[24] + line[25] + line[26] + line[27] + line[28] - (pendingData ? (pendingData[line[0]] || 0) : 0)}</b>, 1, `calculation-${lineIndex}-2`
      )}

      
      {isAUExpanded && (
        <>
          {renderCell(findSKUStatus(line[0], 'AU'), 2, `line3-${lineIndex}-5`)}
          {renderCell(
            tableData && tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].auNextContainer?.date ? 
            moment(tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].auNextContainer?.date)?.format('DD-MM-YYYY') : "", 3, `auNextContainer-${lineIndex}-3`
          )}
          {renderCell(<span className="text-danger">{pendingData && pendingData[line[0]] || 0}</span>, 3, `pendingDataAU-${lineIndex}-4`)}

          {renderCell(line[3], 4, `line3-${lineIndex}-5`)}  {/* EWE MELB */}
          {renderCell(line[6], 5, `line6-${lineIndex}-6`)} {/* EWE SYD */}
          {renderCell(line[18], 6, `line18-${lineIndex}-7`)} {/* EWE BRS */}
          {renderCell(line[19], 6, `line18-${lineIndex}-7`)} {/* EWE PERTH */}
          {renderCell(line[27], 6, `line18-${lineIndex}-7`)} {/* EWE Adelaide */}


          {renderCell(line[1], 7, `line1-${lineIndex}-8`)} {/* HQ2 */}
          {renderCell(line[2], 8, `line2-${lineIndex}-9`)} {/* QV STORE */}
          {renderCell(line[11], 9, `line11-${lineIndex}-10`)} {/* CHADSTONE */}
          {renderCell(line[22], 17, `line17-${lineIndex}-18`)} {/* HIGHPOINT */}
          {renderCell(line[24], 18, `line17-${lineIndex}-15`)} {/* EMPORIUM */}
          {renderCell(line[26], 18, `line17-${lineIndex}-15`)} {/* Doncaster */}
          {renderCell(line[28], 18, `line17-${lineIndex}-15`)} {/* Burnside */}

          {renderCell(line[7], 10, `line7-${lineIndex}-11`)} {/* GALERIES */}
          {renderCell(line[16], 13, `line16-${lineIndex}-14`)} {/* PITT */}
          {renderCell(line[9], 11, `line9-${lineIndex}-12`)} {/* BONDI */}
          {renderCell(line[23], 18, `line17-${lineIndex}-15`)} {/* ROSEBERY */}

          {renderCell(line[17], 14, `line17-${lineIndex}-15`)} {/* JAMES */}
          {renderCell(line[25], 18, `line18-${lineIndex}-18`)} {/* Karrinyup */}
        </>
      )}
      {/*  total us */}
      {
      renderCell(<b>{[line[5], line[14], line[13], line[12]].reduce((sum, val) => sum + (isNaN(val) || val === undefined ? 0 : val), 0) - (pendingDataUS ? (isNaN(pendingDataUS[line[0]]) || pendingDataUS[line[0]] === undefined ? 0 : pendingDataUS[line[0]]) : 0)}</b>, 20, `usCalculation-${lineIndex}-16`)
      }
      

      {isUSExpanded && (
        <>
          {renderCell(findSKUStatus(line[0], 'US'), 21, `line3-${lineIndex}-5`)}
          {renderCell(
            tableData && tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')] && tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].usNextContainer?.date ?
            moment(tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].usNextContainer?.date)?.format('DD-MM-YYYY') : ''
            , 22
            , `usNextContainer-${lineIndex}-17`
          )}
          {renderCell(<span className="text-danger">{pendingDataUS && pendingDataUS[line[0]] || 0}</span>, 17, `pendingDataUS-${lineIndex}-18`)}
          {renderCell(line[14], 23, `line14-${lineIndex}-19`)}
          {renderCell(line[5], 24, `line5-${lineIndex}-20`)}
          {renderCell(line[12], 25, `line12-${lineIndex}-21`)}
          {renderCell(line[13], 26, `line13-${lineIndex}-22`)}
        </>
      )}
      {/*  total uk */}
      {renderCell(<b>{[line[10]].reduce((sum, val) => sum + (isNaN(val) || val === undefined ? 0 : val), 0) - (pendingDataUK ? (isNaN(pendingDataUK[line[0]]) || pendingDataUK[line[0]] === undefined ? 0 : pendingDataUK[line[0]]) : 0)}</b>, 27, `ukCalculation-${lineIndex}-23`)}

      {isUKExpanded && (
        <>
          {renderCell(findSKUStatus(line[0], 'UK'), 28, `line3-${lineIndex}-5`)}
          {renderCell(
            tableData && tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')] && tableData && tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].ukNextContainer?.date ?
            moment(tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].ukNextContainer?.date)?.format('DD-MM-YYYY'): "", 29, `ukNextContainer-${lineIndex}-24`
          )}
          {renderCell(<span className="text-danger">{pendingDataUK && pendingDataUK[line[0]] || 0}</span>, 24, `pendingDataUK-${lineIndex}-25`)}
          {renderCell(line[10], 30, `line10-${lineIndex}-26`)}
        </>
      )}
    </tr>
  );
});

const CategoryRow = React.memo(({ category, categoryGroup, index, expandedProducts, searchTerm, toggleProductSelected, pendingData, pendingDataUS, pendingDataUK, isAUExpanded, isUSExpanded, isUKExpanded, tableData, findSKUStatus }) => {
  const handleCatClicked = () => {
    let allProducts = categoryGroup.map(groupedProduct => groupedProduct.product._id);
    let checker = (arr, target) => target.every(v => arr.includes(v));

    if (checker(expandedProducts, allProducts)) {
      toggleProductSelected([]);
    } else {
      toggleProductSelected(allProducts);
    }
  };

  return (
    <React.Fragment key={`cat-${category}${index}`}>
      <tr className="bg-black"  onClick={handleCatClicked} style={{ userSelect: 'none', background: 'rgb(31, 62, 60)', color: '#fff', cursor: 'pointer' }}>
        <td style={{maxWidth: 250, width: 250, minWidth: 250, position:  'sticky', left: 0 }}><b>{category}</b></td>
      </tr>
      {categoryGroup.map((groupedProduct, productIndex) => {
        const { product, lines } = groupedProduct;

        const isExpanded = expandedProducts.includes(product._id) || searchTerm !== '';

        if (lines.length === 0) return null;

       

        return (
          <React.Fragment key={`prod-${product.name}${productIndex}`}>
            <tr style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => toggleProductSelected([product._id])}>
              <td style={{maxWidth: 250, width: 250, minWidth: 250, position:  'sticky', background: 'white', left: 0}}><b style={{maxWidth: '100%', textWrap: 'auto'}}>{product.name}</b></td>
            </tr>
        

            {isExpanded && lines.map((line, lineIndex) => {
              if (line[0] !== '') {
                return (
                  <LineRenderer
                    findSKUStatus={findSKUStatus}
                    key={`line-${lineIndex}`}
                    line={line}
                    lineIndex={lineIndex}
                    pendingData={pendingData}
                    pendingDataUS={pendingDataUS}
                    pendingDataUK={pendingDataUK}
                    isAUExpanded={isAUExpanded}
                    isUSExpanded={isUSExpanded}
                    isUKExpanded={isUKExpanded}
                    tableData={tableData}
                  />
                )
              }
            })}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
});

const BasicTable = ({fromProduct, productID, skus}) => {
  const [refresh, setRefresh] = useState(true);
  const [isAUExpanded, setAUExpanded] = useState(false);
  const [isUSExpanded, setUSExpanded] = useState(false);
  const [isUKExpanded, setUKExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [inputValue, setInputValue] = useState('');

  const refreshData = () => {
    setRefresh(prev => !prev);
  }


  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearchTerm(value);
    }, 300),
    []
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      setSearchTerm(inputValue);
      debouncedSearch.cancel(); 
    }
  };

  const findSKUStatus = useSKUStatus();


  const [data, state] = useQuery({
    url: `/product/all-stock-v2`,
    queryData: {
      skus: skus,
    },
    refresh,
  });

  const [products, productState] = useQuery({
    url: `/product/findAllTotalStock`,
    refresh,
    queryData: {
      productID: productID,
    },
  });

  const [containers, containerState] = useQuery({
    url: `/inventory/fetchUpcomingContainerTotalStock/`,
    refresh,
  });

  const [tableData, setTableData] = useState({});

  useEffect(() => {
    let toUseContainers = containers || []
    
    if (products) {
    
      const updatedTable = {};

      products?.data.forEach(product => {
        product.variants.forEach(variant => {
          const sku = variant.sku;

          let usLocations = ['USA - Dallas', 'UNIS', 'LCHSLC', 'LCHKTC'];
          let ukLocations = ['Airbox UK'];

          let containerLineData = [...toUseContainers].reverse().map(container => {
            let containerLine = container.containerLines.find(containerLine => containerLine?.sku === sku);
            let count = containerLine == undefined ? 0 : containerLine.quantity;

            let location = container.landingLocation.name;
            let date = container.arrivalDate;
            return {
              count,
              location,
              date,
              country: usLocations.includes(location) ? 'US' : ukLocations.includes(location) ? 'UK' : 'AU'
            };
          }).filter(val => val.count !== 0);

          let usList = containerLineData.filter(val => val.country === 'US');
          let auList = containerLineData.filter(val => val.country === 'AU');
          let ukList = containerLineData.filter(val => val.country === 'UK');

          updatedTable[sku] = {
            usNextContainer: usList.length > 0 ? usList[0] : null,
            auNextContainer: auList.length > 0 ? auList[0] : null,
            ukNextContainer: ukList.length > 0 ? ukList[0] : null,
          };
        });
      });

      setTableData(updatedTable);
    }
  }, [products, containers]);


  const [groupedData, setGroupedData] = useState([]);
  const [expandedProducts, setExpandedProducts] = useState([]);

  const toggleProductSelected = (ids) => {
    setExpandedProducts(prev => {
      const newExpandedProducts = new Set(prev);
      ids.forEach(id => {
        if (newExpandedProducts.has(id)) {
          newExpandedProducts.delete(id);
        } else {
          newExpandedProducts.add(id);
        }
      });
      return Array.from(newExpandedProducts);
    });
  }

  useEffect(() => {
    if (!(data && products && groupedData && setGroupedData && expandedProducts)) {
      return;
    }

    let internalGroupedData = [];

    products?.data.forEach(product => {
      let lines = [];
      product.variants.forEach(variant => {
        let foundLine = data.find(line => line[0] === variant.sku);
        if (variant.isArchived !== true && foundLine && (searchTerm === '' || foundLine[0].toUpperCase().includes(searchTerm.toUpperCase()))) {
          lines.push(foundLine);
        }
      });
      if (product.isArchived !== true && lines.length !== 0) {
        internalGroupedData.push({
          product: {
            ...product,
            categoryIndex: categories.findIndex(val => val === product.category) || 10,
          },
          lines: lines.sort((a, b) => a[0].localeCompare(b[0]))
        });
      }
    });

    internalGroupedData = internalGroupedData.filter(val => val.lines.length !== 0).sort((a, b) => a.product.name.localeCompare(b.product.name));

    const categoryGrouped = groupBy(internalGroupedData, productGroup => productGroup.product.category);

    console.log("categoryGrouped", categoryGrouped);
    setGroupedData(categoryGrouped);

  }, [data, products, setGroupedData, expandedProducts, searchTerm]);

  const [pendingData, pendingState] = useQuery({
    url: `/inventory/pendingStock`,
    refresh,
  });

  const [pendingDataUS, pendingUSState] = useQuery({
    url: `/inventory/pendingStockUS`,
    refresh,
  });

  const [pendingDataUK, pendingUKState] = useQuery({
    url: `/inventory/pendingStockUK`,
    refresh,
  });

  const dateString = (new Date()).toDateString().replace(' ', '-').replace(' ', '-').replace(' ', '-');

  const csvData = useMemo(() => {
    // First row is headers
    const headers = [
      'SKU',
      // AU Section
      'AU TOTAL',
      'AU STATUS',
      'AU CONTAINER',
      'PENDING AU',
      // AU EWE Stores
      'EWE - Melbourne',
      'EWE - Sydney',
      'EWE - Brisbane',
      'EWE - Perth',
      'EWE - Adelaide',
      // AU Melbourne Stores
      'HQ2',
      'QV Store',
      'Chadstone',
      'Highpoint',
      'Emporium',
      'Doncaster',
      'Burnside',
      // AU Sydney Stores
      'Galeries Store',
      'Pitt St',
      'Bondi',
      'Rosebery',
      // AU Brisbane Store
      'James St',
      'Karrinyup',
      // US Section
      'US TOTAL',
      'US STATUS',
      'US CONTAINER',
      'PENDING US',
      'GREEEN ST',
      'UNIS',
      'KENTUCKY',
      'UTAH',
      // UK Section
      'UK TOTAL',
      'UK STATUS',
      'UK CONTAINER',
      'PENDING UK',
      'Airbox'
    ];
  
    // If we don't have all required data, return just headers
    if (!data || !products || !pendingData || !pendingDataUS || !pendingDataUK) {
      return [headers];
    }
  
    // Create ordered data rows
    let orderedRows = [];
    
    // Group products by category and sort them
    let internalGroupedData = [];
    products.data.forEach(product => {
      let lines = [];
      product.variants.forEach(variant => {
        let foundLine = data.find(line => line[0] === variant.sku);
        if (variant.isArchived !== true && foundLine) {
          lines.push(foundLine);
        }
      });
      if (product.isArchived !== true && lines.length !== 0) {
        internalGroupedData.push({
          product: {
            ...product,
            categoryIndex: categories.findIndex(val => val === product.category) || 10,
          },
          lines: lines.sort((a, b) => a[0].localeCompare(b[0]))
        });
      }
    });
  
    // Sort products within their categories
    internalGroupedData = internalGroupedData
      .filter(val => val.lines.length !== 0)
      .sort((a, b) => a.product.name.localeCompare(b.product.name));
  
    // Group by category
    const categoryGrouped = groupBy(internalGroupedData, productGroup => productGroup.product.category);
  
    // Process each category in order
    categories.forEach(category => {
      const categoryGroup = categoryGrouped[category];
      if (categoryGroup) {
        // For each product in the category
        categoryGroup.forEach(({ lines }) => {
          // Add each line's data
          lines.forEach(line => {
         
            if (line[0] !== '') {
              orderedRows.push([
                line[0], // SKU
                // AU Total and Info
                line[1] + line[2] + line[3] + line[6] + line[7] + line[9] + line[11] + line[16] + line[17] +
                line[18] + line[19] + line[22] + line[23] + line[24] + line[25] + line[26] + line[27] + line[28] - (pendingData ? (pendingData[line[0]] || 0) : 0),
                findSKUStatus(line[0], 'AU'),
                tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')]?.auNextContainer?.date ? 
                  moment(tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].auNextContainer?.date)?.format('DD-MM-YYYY') : '',
                pendingData[line[0]] || 0,
                // AU EWE Stores
                line[3],  // EWE Melbourne
                line[6],  // EWE Sydney
                line[18], // EWE Brisbane
                line[19], // EWE Perth
                line[27], // EWE Adelaide
                // AU Melbourne Stores
                line[1],  // HQ2
                line[2],  // QV Store
                line[11], // Chadstone
                line[22], // Highpoint
                line[24], // Emporium
                line[26], // Doncaster
                line[28], // Burnside
                // AU Sydney Stores
                line[7],  // Galeries Store
                line[16], // Pitt St
                line[9],  // Bondi
                line[23], // Rosebery
                // AU Brisbane Store
                line[17], // James St
                line[25], // Karrinyup
                // US Total and Info
                line[5] + line[14] + line[13] + line[12] - (pendingDataUS ? (pendingDataUS[line[0]] || 0) : 0),
                findSKUStatus(line[0], 'US'),
                tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')]?.usNextContainer?.date ?
                  moment(tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].usNextContainer?.date)?.format('DD-MM-YYYY') : '',
                pendingDataUS[line[0]] || 0,
                line[14], // GREEEN ST
                line[5],  // UNIS
                line[12], // KENTUCKY
                line[13], // UTAH
                // UK Total and Info
                line[10] - (pendingDataUK ? (pendingDataUK[line[0]] || 0) : 0),
                findSKUStatus(line[0], 'UK'),
                tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')]?.ukNextContainer?.date ?
                  moment(tableData[line[0].split('-').filter((val) => val !== 'P' && val !== 'LE').join('-')].ukNextContainer?.date)?.format('DD-MM-YYYY') : '',
                pendingDataUK[line[0]] || 0,
                line[10]  // Airbox
              ]);
            }
          });
        });
      }
    });
  
    return [headers, ...orderedRows];
  }, [data, products, pendingData, pendingDataUS, pendingDataUK, tableData, findSKUStatus, categories]);

  const allSelected = expandedProducts?.length === products?.data?.length || searchTerm !== '';
  const toggleProductSelectedAll = () => {
    if (allSelected) {
      setExpandedProducts([]);
      setSearchTerm('');
    } else {
      setExpandedProducts(products?.data.map(product => product._id));
    }
  }

  if(fromProduct && !productID) {
    return <div>No Data</div>
  }

  return (
    <div className={`${!productID ? 'page-content' :""}`}>
      <div className={`${!productID ? 'container-fluid' :""}`}>
        {!productID && <Breadcrumbs title="Inventory" breadcrumbItem="All Locations" />}
        <div>
          {!productID && <Row style={{ background: '#fff', borderTopLeftRadius: 16, borderTopRightRadius: 16 }}>
            <Col  className="sm:w-2/12" style={{ padding: 16 }}>
              <Button type="button" variant={!allSelected ? 'success' : 'warning'} className="btn-lg btn-rounded" onClick={toggleProductSelectedAll}> {!allSelected ? 'Expand All' : searchTerm !== '' ? 'Close All & Clear' : 'Close All'} </Button>
            </Col>
            <Col  className="sm:w-8/12" style={{ paddingBottom: 8 }}>
              <div className="app-search d-none d-lg-block">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search, then press Enter..."
                    value={inputValue}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}      
                  />
                  <span className="bx bx-search-alt"></span>
                </div>
              </div>
            </Col>
            <Col sm="2" className="sm:w-2/12" style={{ padding: 16 }}>
              <CSVLink
                style={{ float: 'right' }}
                data={csvData}
                filename={`TOTAL_STOCK_${dateString}.csv`}
              >
                <Button type="button" variant="secondary" className="btn-lg btn-rounded">
                  CSV
                </Button>
              </CSVLink>
            </Col>
          </Row>}
        </div>
        <Row>
          <Col>
            <Card className='pt-6 mb-6 rounded-none border-0'>
              <CardBody>
               {  !productID && <CardTitle className="text-[15px] mb-2">Total Stock Levels</CardTitle>}
                <div style={{
                  display: 'block',
                  width: '100%',
                  overflowX: 'auto',
                  overflowY: 'scroll',
                  height: 'calc(70vh)',
                  whiteSpace: 'nowrap'
                }}>
                  {data ? (
                    <table className="table mb-0">
                      <thead style={{ position: 'sticky', top: -1, zIndex: 9, background: 'white' }}>
                        <tr>
                          <th style={{ cursor: 'default' }}></th>
                          <th onClick={() => setAUExpanded(prev => !prev)}>
                            <b>AU Avaliable</b>
                            {isAUExpanded ? (
                              <i className="bx bx-caret-right"></i>
                            ) : (
                              <i className="bx bx-caret-down"></i>
                            )}
                          </th>
                          {isAUExpanded && (
                            <>
                              <th>STATUS</th>
                              <th>CONTAINER</th>
                              <th>PENDING AU</th>

                              <th>EWE - Melbourne</th>
                              <th>EWE - Sydney</th>
                              <th>EWE - Brisbane</th>
                              <th>EWE - Perth</th>
                              <th>EWE - Adelaide</th>

                              <th>HQ2</th>
                              <th>QV Store</th>
                              <th>Chadstone</th>
                              <th>Highpoint</th>
                              <th>Emporium</th>
                              <th>Doncaster</th>
                              <th>Burnside</th>

                              <th>Galeries Store</th>
                              <th>Pitt St</th>
                              <th>Bondi</th>
                              <th>Rosebery</th>

                              <th>James St</th>
                              <th>Karrinyup</th>
                            </>
                          )}
                          <th onClick={() => setUSExpanded(prev => !prev)}>
                            <b>US Avaliable</b>
                            {isUSExpanded ? (
                              <i className="bx bx-caret-right"></i>
                            ) : (
                              <i className="bx bx-caret-down"></i>
                            )}
                          </th>
                          {isUSExpanded && (
                            <>
                              <th>STATUS</th>
                              <th>CONTAINER</th>
                              <th>PENDING US</th>
                              <th>GREEEN ST</th>
                              <th>UNIS</th>
                              <th>KENTUCKY</th>
                              <th>UTAH</th>
                            </>
                          )}
                          <th onClick={() => setUKExpanded(prev => !prev)}>
                            <b>UK Avaliable</b>
                            {isUKExpanded ? (
                              <i className="bx bx-caret-right"></i>
                            ) : (
                              <i className="bx bx-caret-down"></i>
                            )}
                          </th>
                          {isUKExpanded && (
                            <>
                              <th>STATUS</th>
                              <th>CONTAINER</th>
                              <th>PENDING UK</th>
                              <th>Airbox</th>
                            </>
                          )}
                        </tr>
                      </thead>
                      {console.log("current category", categories, groupedData)}
                      <tbody>
                        {categories.map((category, index) => {
                          const categoryGroup = groupedData[category];
                          if (!categoryGroup) return null;

                          return (
                            <CategoryRow
                              findSKUStatus={findSKUStatus}
                              key={`cat-${category}${index}`}
                              category={category}
                              categoryGroup={categoryGroup}
                              index={index}
                              expandedProducts={expandedProducts}
                              searchTerm={searchTerm}
                              toggleProductSelected={toggleProductSelected}
                              pendingData={pendingData}
                              pendingDataUS={pendingDataUS}
                              pendingDataUK={pendingDataUK}
                              isAUExpanded={isAUExpanded}
                              isUSExpanded={isUSExpanded}
                              isUKExpanded={isUKExpanded}
                              tableData={tableData}
                            />
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <div className="spinner-border text-primary m-1" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default BasicTable;
